import { LazyRoute } from "common/routes/route.types";
import { routes } from "common/routes/routes";

/*
 * The settings-owned routes. The Best Health Booking screens shown under
 * /settings/bhb are owned by the booking module and are grafted onto this tree
 * by the composition root (layout/Shell), so settings does not depend on
 * booking.
 */
export const settingRoutes: LazyRoute = {
  ...routes.settings.basePath,
  id: routes.settings.basePath.text,
  importComponent: () => import("modules/settings/Index"),
  children: [
    {
      ...routes.settings.networkAndSecurity,
      importComponent: () =>
        import("modules/settings/pages/NetworkAndSecurityScreen"),
      id: routes.settings.networkAndSecurity.text
    },
    {
      ...routes.settings.mobileLicences,
      importComponent: () =>
        import("modules/settings/pages/UserLicencesScreen"),
      id: routes.settings.mobileLicences.text
    },
    {
      ...routes.settings.home,
      importComponent: () => import("modules/settings/pages/ProductsScreen"),
      id: routes.settings.home.text
    }
  ]
};
